import { render, staticRenderFns } from "./ordermanagementdrying.vue?vue&type=template&id=f2a18cca&"
import script from "./ordermanagementdrying.vue?vue&type=script&lang=ts&"
export * from "./ordermanagementdrying.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordermanagementdrying.vue"
export default component.exports